import React from 'react';
import { AuthStatus, useAuthContext } from '@isyc-react/auth/modules/context';
import { BrowserRouter } from 'react-router-dom';
import { RouterUnlogged } from './router.unlogged.component';
import { RouterLogged } from './router.logged.component';
import { GlobalLoader } from 'pods/loader';
import { defaultUserPermissionObjectTypeIds, UserPermissionProvider } from '@isyc-react/form/modules/context';
import { LookAndFeelProvider, BuConfigProvider } from '@isyc-react/oncustomer/modules/objects/business-unit';
import { namespaces } from 'i18n/i18n.constants';
const basename = '/documentation';
const userPermissionObjectTypeIds = [
    ...defaultUserPermissionObjectTypeIds,
    // DEFAULTS
];
export const Router = () => {
    const { status, user } = useAuthContext();
    // if (window.location.pathname === '/') {
    //   window.location.replace(basename)
    // }
    return (React.createElement(BrowserRouter, { basename: basename }, status === AuthStatus.LOADING ? (React.createElement(React.Fragment, null,
        React.createElement(GlobalLoader, null))) : (React.createElement(React.Fragment, null, status === AuthStatus.LOGGED ? (React.createElement(React.Fragment, null,
        React.createElement(UserPermissionProvider, { objectTypeIds: userPermissionObjectTypeIds, components: { Loading: GlobalLoader } },
            React.createElement(LookAndFeelProvider, { components: { Loading: GlobalLoader } },
                React.createElement(BuConfigProvider, { components: { Loading: GlobalLoader }, namespace: namespaces.common, i18n: true },
                    React.createElement(RouterLogged, null)))))) : (React.createElement(React.Fragment, null,
        React.createElement(RouterUnlogged, null)))))));
};
